import {useEffect, useState} from 'react';
import { useMediaQuery } from '@mui/material';
import {useGetHomePageService } from 'app/utils/services/homePageService';
import {useLayoutContext} from 'app/storage/LayoutContext';
import { useParams } from 'react-router-dom';
import { AccountValue } from 'app/constants/types';

import { useTranslation } from 'react-i18next';
import { getTheme } from 'app/components/ThemeProvider/theme';

const useHomePage = () => {
  const theme = getTheme('light');

  const { t } = useTranslation();
  const [showAddBanner, setShowAddBanner] = useState(false);
  const [showCalculator, setShowCalculator] = useState(false);
  const largeScreens = useMediaQuery(theme.breakpoints.down('lg'));
  const mediumScreens = useMediaQuery(theme.breakpoints.down('md'));
  const smallScreens = useMediaQuery(theme.breakpoints.down('sm'));
  const [expand, setExpand] = useState(false);
  const [selectValue, setSelectValue] = useState<AccountValue>();
  const { lang } = useParams();
  const [fromHomePage, setFromHomePage] = useState(true);
  const [currentLang, setCurrentLang] = useState(lang);

  const { isLoadingGetHomePage, dataGetHomePage, refetchGetHomePage } = useGetHomePageService();
  const {layoutState, setLayoutState,updateGlobalState} = useLayoutContext();


  useEffect(() => {
    setLayoutState((prevUserState: any) => ({
      ...prevUserState,
      accounts: dataGetHomePage?.accounts_list
    }));
  }, [dataGetHomePage]);

  useEffect(() => {
    refetchGetHomePage();
  }, [lang]);

  useEffect(() => {
    if (largeScreens) {
      setExpand(false);
    }
  }, [largeScreens]);

  const handleExpand = () => {
    setExpand(!expand);
  };

  return {
    t,
    isLoadingGetHomePage,
    dataGetHomePage,
    showAddBanner,
    largeScreens,
    showCalculator,
    expand,
    selectValue,
    fromHomePage,
    setFromHomePage,
    setSelectValue,
    setShowCalculator,
    setShowAddBanner,
    handleExpand,
    mediumScreens,
    smallScreens,
  };
};

export default useHomePage;
